export const MODAL_BIG = 'big';
export const MODAL_DEFAULT = 'default';

export const MODAL_SIZES = [
    MODAL_BIG,
    MODAL_DEFAULT,
];
